import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const VisaLogo = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(base: {eq: "visa.png"}, relativeDirectory: {eq: "footer"}) {
        childImageSharp {
          fixed(height: 29) {
            originalName
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return <Img fixed={data.placeholderImage.childImageSharp.fixed} />
}

export default VisaLogo
